import { Component, OnInit } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import { MpsUserService } from '../../../../../mps/mps-auth';
import {User} from 'src/app/models/user';

const nbColumnMax = 5;
const defaultNbColumn = 3;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private userService: MpsUserService,
        private snackbar: MatSnackBar
    ) {
        this.activatedRoute.queryParams.subscribe(
            (params: any) => {
                const token = params._et;
                if (token) {
                    let user = new User(this.userService.getUser().getValue());
                    
                    if (this.userService.getUser().getValue()) {
                        if (user.isAdmin() || user.isReferent() || user.isRH()) {
                            this.router.navigate(['/secondees-list']);
                        } else {
                            this.router.navigate(['/interview/' + user.secondee?.id + '/form']); // Pas de formulaire ou poser question
                        }
                    } else {
                        this.snackbar.open('Authentication failed');
                        this.router.navigate(['/']);
                    }
                }
            }
        );
    }

    ngOnInit(): void {
        console.log('iiinn2');
    }
}
